import { http } from "../utils/http";
import { OperatorDto } from "../dto/postLogin";
import { RolesDto } from "../dto/roles";
import { TeamDto } from "../dto/team";
import { TemplateCategoryDto } from "../dto/templateCategory";
import { TemplateDto, TemplateVariableDto } from "../dto/template";

// ─── Operators ────────────────────────────────────────────────────────────────

export const fetchAllOperators = async (): Promise<OperatorDto[]> => {
  const res = await http.get("/api/Operators");
  return res.data?.operators ?? [];
};

export type CreateOperatorRequest = {
  name: string;
  email: string;
  teamId: string;
  roleId: string;
};

export type UpdateOperatorRequest = {
  name: string;
  teamId: string;
  roleId: string;
  isActive: boolean;
};

export const createOperator = async (
  req: CreateOperatorRequest
): Promise<OperatorDto> => {
  const res = await http.post("/api/Operators", req);
  return res.data;
};

export const updateOperator = async (
  id: string,
  req: UpdateOperatorRequest
): Promise<OperatorDto> => {
  const res = await http.put(`/api/Operators/${id}`, req);
  return res.data;
};

// ─── Teams ────────────────────────────────────────────────────────────────────

export const fetchTeams = async (): Promise<TeamDto[]> => {
  const res = await http.get("/api/Teams");
  return res.data?.teams ?? res.data ?? [];
};

// ─── Roles ────────────────────────────────────────────────────────────────────

export const fetchRoles = async (): Promise<RolesDto[]> => {
  const res = await http.get("/api/Roles");
  return res.data?.roles ?? res.data ?? [];
};

// ─── Template Categories ──────────────────────────────────────────────────────

export const fetchTemplateCategories = async (): Promise<
  TemplateCategoryDto[]
> => {
  const res = await http.get("/api/Templates/categories");
  return res.data ?? [];
};

// ─── Templates ────────────────────────────────────────────────────────────────

export const fetchAllTemplates = async (): Promise<TemplateDto[]> => {
  const res = await http.get("/api/Templates", { params: { active: null } });
  return res.data ?? [];
};

export type CreateTemplateRequest = {
  name: string;
  content: string;
  templateSid: string;
  teamIds: string[];
  variables: TemplateVariableDto[];
  categoryId?: string | null;
};

export type UpdateTemplateRequest = CreateTemplateRequest & {
  isActive: boolean;
};

export const createTemplate = async (
  req: CreateTemplateRequest
): Promise<TemplateDto> => {
  const res = await http.post("/api/Templates", req);
  return res.data;
};

export const updateTemplate = async (
  id: string,
  req: UpdateTemplateRequest
): Promise<TemplateDto> => {
  const res = await http.put(`/api/Templates/${id}`, req);
  return res.data;
};
